<template>
  <video
    class="mfp-popup-video"
    id="heroVideoPopup"
    autoplay=""
    controls=""
    controlslist="nodownload"
    :src="videoSrc"
    type="video/mp4"
  >
  </video>
</template>

<script>
  export default {
    name: 'video-player',
    props: {
      videoSrc: String
    }
  }
</script>

<style lang="scss" scoped>
  #heroVideoPopup {
    width: 100%;
    display: flex;
  }
</style>
